import React from 'react';
import { InfoWindowF } from '@react-google-maps/api';
import { Box, useTheme, IconButton } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

// A wrapper component to handle dark mode styling for InfoWindow content
const DarkModeInfoWindow = ({ children, position, onCloseClick, options, colorMode }) => {
  const theme = useTheme();
  const darkBg = theme.colors.gray[800];

  return (
    <InfoWindowF
      position={position}
      onCloseClick={onCloseClick}
      options={{
        ...options,
        backgroundColor: darkBg,
      }}
    >
      <Box className="info-window-wrapper" p={2}>
        <style>
          {`
          /* Target InfoWindow and all its internal elements */
          .gm-style-iw-c,
          .gm-style-iw-d,
          .gm-style-iw-t::after,
          .gm-style-iw-tc,
          .gm-style .gm-style-iw-tc::after {
            background: ${colorMode === 'dark' ? darkBg : 'white'} !important;
            box-shadow: none !important;
          }

          /* Remove padding from containers */
          .gm-style-iw.gm-style-iw-c {
            padding: 0 !important;
          }

          .gm-style-iw-d {
            overflow: hidden !important;
            padding: 0 !important;
          }

          /* Hide default close button */
          .gm-ui-hover-effect {
            display: none !important;
          }

          /* Hide the tail/arrow element */
          .gm-style-iw-t::after,
          .gm-style-iw-tc::after {
            display: none !important;
          }

          /* Ensure all child elements inherit background */
          .gm-style-iw * {
            background-color: ${colorMode === 'dark' ? darkBg : 'white'} !important;
          }
        `}
      </style>
        <Box position="relative">
          <IconButton
            position="absolute"
            right={2}
            top={2}
            size="sm"
            icon={<CloseIcon />}
            onClick={onCloseClick}
            zIndex={2}
            variant="ghost"
            isRound
            aria-label="Close info window"
            color={colorMode === 'dark' ? 'gray.300' : 'gray.600'}
            transition="all 0.2s"
            _hover={{
              bg: colorMode === 'dark' ? 'gray.700' : 'gray.100',
              transform: 'scale(1.1)',
              color: colorMode === 'dark' ? 'white' : 'black'
            }}
          />
          <Box
            bg={colorMode === 'dark' ? darkBg : 'white'}
            borderRadius="lg"
            overflow="hidden"
          >
            {children}
          </Box>
        </Box>
      </Box>
    </InfoWindowF>
  );
};

export default DarkModeInfoWindow;
